import React from 'react';
import AppLoadingPlaceholder from "expo/build/launch/AppLoadingPlaceholder";
import {Provider} from "react-redux";
import store from "./Store/configureStore";
import {initializeAccount} from "./Store/Reducers/AuthReducer";
import {setOnline} from "./Store/Reducers/SwReducer";
import NavigationStack from "./Navigation/Navigation";
import persistStore from "redux-persist/es/persistStore";
import {PersistGate} from "redux-persist/integration/react";
import { useFonts } from 'expo-font';
import initI18n from "./lang/i18n";

import registerSW, {swRegistrationUpdate} from "./sw/sw_registration";
// import { setupSwHelper } from "./sw/helpers";

let persistor = persistStore(store)

// https://medium.com/@madridserginho/how-to-handle-webpush-api-pushsubscriptionchange-event-in-modern-browsers-6e47840d756f
// https://web.dev/explore/notifications?hl=fr

// <OFFLINE>

const { web_public_url } = getGlobalVars()
// FIXME: should be /app only
const sw_scope = '/';


// register sw as soon as possible
// could be after NIP to check if this is a first install and load stuff accordingly
// (could also be stored...)
registerSW(web_public_url + 'reticular-service-worker.js', sw_scope).then(() => {
  console.log('[sw setup] registration success');
}, () => {
  console.log('[sw setup] registration failure');
})


window.addEventListener('online',  updateOnlineStatus);
window.addEventListener('offline', updateOnlineStatus);

function updateOnlineStatus(event) {
  store.dispatch(setOnline(navigator.onLine));

  if (navigator.onLine) {
    // check account again in case we are logged out
    store.dispatch(initializeAccount());

    swRegistrationUpdate();
  }
}


// setupSwHelper(store);

// </OFFLINE>


// on app start: fetch/dispatch account as fast as possible
let _init_promise = store.dispatch(initializeAccount());

export default (props) => {
    let [fontsLoaded] = useFonts({
        'Poppins-SemiBold' : require('./assets/fonts/Poppins-SemiBold.ttf'),
        'Manrope-Medium' : require('./assets/fonts/Manrope-Medium.ttf'),
        'Manrope-bold' : require('./assets/fonts/Manrope-Bold.ttf'),
    });

    // if (!fontsLoaded) { return <AppLoadingPlaceholder />; }
    // https://github.com/rt2zz/redux-persist/blob/master/docs/PersistGate.md
    const onBeforeLift = () => {
      initI18n();

      return _init_promise;
    }

    return (
        <Provider store={store}>
            <PersistGate persistor={persistor} onBeforeLift={onBeforeLift}>
                <NavigationStack />
            </PersistGate>
        </Provider>
    );

};
